import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styles from './styles.css';

const NavigationLink = ({ link }) => (
  <NavLink exact={link.exact} to={`/${link.path}`} activeClassName='active' className='nav-link'>
    <i className={`col-xs ${styles.icon} fa ${link.icon}`} />
    <span className='col-xs-offset-1 col-xs'>{link.name}</span>
  </NavLink>
);

NavigationLink.propTypes = {
  link: PropTypes.object.isRequired
};

export default NavigationLink;



// WEBPACK FOOTER //
// ./src/components/Navigation/components/NavigationLink/component.js